import { jsx as _jsx } from "react/jsx-runtime";
import { toast } from '@repo/toast';
import { useEffect } from 'react';
import { getLabels } from '../../labels';
const TOAST_ID = 'priceLoadingError';
export default function PriceErrorIndicator({ testId }) {
    useEffect(() => {
        toast.danger(getLabels().price.parking_price_error.toast, testId.append('toast'), {
            id: TOAST_ID,
        });
    }, [testId]);
    return (_jsx("div", { className: "text-fg-warning inline-flex items-center justify-end self-stretch p-1.5", "data-testid": testId, children: _jsx("span", { className: "text-xs font-medium", children: getLabels().price.parking_price_error.label }) }));
}
